import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Contact from '../components/Contact';

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // 🔹 STRATEGIC SEO CONSTANTS FOR LOCAL GOOGLE SEARCH RANKING
  const seoTitle = "Contact Admissions Desk Indore | Ciqura Labs Support";
  const seoDescription = "Get in touch with Ciqura Labs at Shagun Arcade, Vijay Nagar, Indore. Inquire about batch registration timelines, professional syllabus details, and internship allocations.";
  const canonicalUrl = "https://ciquralabs.ciqur24.com/contact";

  return (
    <>
      <Helmet>
        {/* Basic Indexing Head Tags */}
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content="Contact Ciqura Labs, Indore tech hub contact number, Shagun Arcade training office, cybersecurity admission desk Indore, WhatsApp technical support, Vijay Nagar IT institute" />
        <link rel="canonical" href={canonicalUrl} />

        {/* Open Graph Protocols for Shared Links (WhatsApp, LinkedIn, Social Link Cards) */}
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:image" content="https://res.cloudinary.com/dlz8euavh/image/upload/v1769179291/3_zbjtyy.png" />
        
        {/* Twitter Card Layout Mapping */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
      </Helmet>

      {/* Main Page Layout View wrapper */}
      <div style={{ background: 'var(--bg-primary)', minHeight: '100vh', paddingTop: '80px' }}>
        <Contact />
      </div>
    </>
  );
};

export default ContactPage;